<template>
  <v-card class="section-card pa-6 mt-6" elevation="0">
    <div class="d-flex align-center mb-6">
      <div class="icon-circle mr-4">
        <v-icon color="#2563eb">mdi-card-account-details-outline</v-icon>
      </div>
      <div>
        <h3 class="text-h6 font-weight-bold mb-0">ข้อมูลส่วนตัวและตัวตน</h3>
        <p class="text-caption grey--text mb-0">ข้อมูลประจำตัวตามบัตรประชาชนที่ใช้ในการลงทะเบียน</p>
      </div>
    </div>

    <v-form ref="form">
      <v-row>
        <v-col cols="12" md="4">
          <span class="detail-label">เลขบัตรประชาชน</span>
          <v-text-field
            v-model="form.natId_nationalId"
            placeholder="เลขบัตรประชาชน 13 หลัก"
            outlined
            dense
            hide-details="auto"
            class="mt-1"
            prepend-inner-icon="mdi-numeric"
            readonly
            disabled
          ></v-text-field>
          <p class="text-caption grey--text mt-1">ไม่อนุญาตให้แก้ไขเลขบัตรประชาชน</p>
        </v-col>

        <v-col cols="12" md="2">
          <span class="detail-label">คำนำหน้า</span>
          <v-select
            v-model="form.natId_prefix"
            :items="['นาย', 'นาง', 'นางสาว']"
            outlined
            dense
            hide-details="auto"
            class="mt-1"
          ></v-select>
        </v-col>

        <v-col cols="12" md="3">
          <span class="detail-label">ชื่อจริง (ไทย)</span>
          <v-text-field
            v-model="form.natId_firstName"
            placeholder="ชื่อจริง"
            outlined
            dense
            hide-details="auto"
            class="mt-1"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3">
          <span class="detail-label">นามสกุล (ไทย)</span>
          <v-text-field
            v-model="form.natId_lastName"
            placeholder="นามสกุล"
            outlined
            dense
            hide-details="auto"
            class="mt-1"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4">
          <span class="detail-label">วันเกิด</span>
          <v-text-field
            v-model="form.natId_birthDate"
            type="date"
            outlined
            dense
            hide-details="auto"
            class="mt-1"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <span class="detail-label">ชื่อจริง (EN)</span>
          <v-text-field
            v-model="form.natId_firstName_en"
            placeholder="First Name"
            outlined
            dense
            hide-details="auto"
            class="mt-1"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <span class="detail-label">นามสกุล (EN)</span>
          <v-text-field
            v-model="form.natId_lastName_en"
            placeholder="Last Name"
            outlined
            dense
            hide-details="auto"
            class="mt-1"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4">
          <span class="detail-label">วันที่ออกบัตร</span>
          <v-text-field
            v-model="form.natId_issueDate"
            type="date"
            outlined
            dense
            hide-details="auto"
            class="mt-1"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <span class="detail-label">วันที่บัตรหมดอายุ</span>
          <v-text-field
            v-model="form.natId_expireDate"
            type="date"
            outlined
            dense
            hide-details="auto"
            class="mt-1"
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="d-flex justify-end mt-6">
        <v-btn
          color="#2563eb"
          dark
          depressed
          @click="save"
          :loading="loading"
          min-width="120"
          height="40"
          style="border-radius: 8px; text-transform: none;"
        >
          บันทึกข้อมูลส่วนตัว
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: "SellerIdentityCard",
  props: {
    data: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      form: {
        natId_nationalId: "",
        natId_prefix: "",
        natId_firstName: "",
        natId_lastName: "",
        natId_firstName_en: "",
        natId_lastName_en: "",
        natId_birthDate: "",
        natId_issueDate: "",
        natId_expireDate: ""
      }
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(v) {
        if (!v) return;
        this.form = {
          natId_nationalId: v.natId_nationalId || "",
          natId_prefix: v.natId_prefix || "",
          natId_firstName: v.natId_firstName || "",
          natId_lastName: v.natId_lastName || "",
          natId_firstName_en: v.natId_firstName_en || "",
          natId_lastName_en: v.natId_lastName_en || "",
          natId_birthDate: v.natId_birthDate || "",
          natId_issueDate: v.natId_issueDate || "",
          natId_expireDate: v.natId_expireDate || ""
        };
      }
    }
  },
  methods: {
    save() {
      this.$emit("save", { ...this.form });
    }
  }
};
</script>

<style scoped>
.section-card {
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
}
.icon-circle {
  width: 44px;
  height: 44px;
  background: #eff6ff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detail-label {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}
:deep(.v-text-field--outlined fieldset) {
  border-color: #e2e8f0;
}
:deep(.v-text-field--outlined.v-input--is-focused fieldset) {
  border-color: #2563eb;
}
</style>
